import { useCallback, useEffect, useState } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const GetLotsWithMostRevisions = () => {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState();
    const [variant, setVariant] = useState();

    const getRevisions = useCallback(async () => {
        setLoading(true);
        await fetchDataAuthenticated("api/v1/admin/lotsWithRevisions/10", "GET")
            .then(response => {
                if (response.status === 403) {
                    return Promise.reject({ title: "Unauthorised", detail: "Unable to fetch lots with most revisions due to being unauthorised. Admin privilege required" });
                }
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setError("");
                setLots(data);
                if (data.length === 0) {
                    setVariant("warning");
                }
                else {
                    setVariant("");
                }
            })
            .catch(error => {
                setLots();
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setError(error.detail);
            })
            .finally(() => setLoading(false));
        ;
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getRevisions();
    }, [getRevisions]);

    function RevisionsTable() {
        if (loading) {
            return (<Spinner />);
        }
        if (error) {
            return (<div>{error}</div>);
        }

        if (lots.length === 0) {
            return (<div>No Lots</div>);
        }

        return (
            <Table>
                <thead>
                    <tr>
                        <th>Lot Number</th>
                        <th>Lot Revisions</th>
                    </tr>
                </thead>
                <tbody>
                    {lots && lots.map((lot, index) =>
                        <tr key={`lot-revision-table-${lot.lotNumber}`}>
                            <td><Link to={{ pathname: `/lotdetails/${lot.lotNumber}` }}>{lot.lotNumber}</Link></td>
                            <td>{lot.numberOfRevisions}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        )
    }

    return (
        <AdminTile
            title={"Lots With The Most Revisions"}
            description={"View the lots with the most lot revisions and purge them"}
            variant={variant}
            onRefresh={getRevisions}>
            <RevisionsTable />
        </AdminTile>
    );
}

export default GetLotsWithMostRevisions;